import axios from 'axios'

const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL
        this.setHeader();
    },

    setHeader() {
        // axios.defaults.headers.common["MEMBERPRESS-API-KEY"] = process.env.VUE_APP_MEMBERPRESS_API_KEY;
        // axios.defaults.headers.common['X-WP-Nonce'] = window.wpApiSettings ? window.wpApiSettings.nonce : 'foobar';
    },

    get(resource) {
        return axios.get(resource)
    },

    getPost(resource) {
        const result = axios.get(resource);
        this.init();
        return result;
    },

    post(resource, data) {
        return axios.post(resource, data)
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        return axios(data)
    },
}

export default ApiService